import React, {useState} from 'react';
import styled from 'styled-components';
import {injectIntl} from 'react-intl';
import Input from '../../components/new-ui/input_field';
import {CSS_CONSTANTS} from '../../css_variables';
import GenericModal from './generic_modal';
import {BUTTON_COLOR, BUTTON_STYLE, PERIOD_BUDGET_TYPE, PERIODICITY} from '../../constants';
import Util from '../../forecast-app/shared/util/util';

const AddPeriodsModalStyle = styled.div`
	.sub-header {
		color: ${CSS_CONSTANTS.v2_text_gray};
		font-size: 13px;
		margin-bottom: 28px;
	}
	.input-totals-container {
		display: flex;
		.input-container-v2 {
			width: 50px;
			margin-right: 66px;
			.input-value-container {
				height: 30px;
				border-color: ${props => (!props.isInputValid ? CSS_CONSTANTS.v2_border_invalid : '')};
			}
		}
	}
	.retainer-totals {
		display: flex;
		justify-content: space-between;
		width: 320px;
		height: 51px;
		.retainer-totals-container {
			display: flex;
			flex-direction: column;
			&.value-section {
				flex-grow: 1;
				text-align: right;
			}
			label {
				font-size: 9px;
				text-transform: uppercase;
				font-weight: 500;
				line-height: 1.22;
				margin-bottom: 5px;
				letter-spacing: 1px;
				color: ${CSS_CONSTANTS.v2_text_light_gray};
			}
			.retainer-bloc {
				display: flex;
				height: 30px;
				font-size: 13px;
				color: ${CSS_CONSTANTS.v2_text_gray};
				background: ${CSS_CONSTANTS.color_medium_gray};
				align-items: center;
				justify-content: space-between;
				&.dates {
					position: relative;
					padding-left: 10px;
					.start-period-date {
						position: absolute;
						height: 30px;
						width: 30px;
						left: -30px;
						top: 4px;
					}
				}
				&.value {
					text-align: right;
					padding-right: 10px;

					.inner-text {
						width: 100%;
					}
				}
			}
		}
	}
`;

const AddPeriodsModal = ({
	intl,
	intl: {formatMessage},
	handleConfirm,
	closeModal,
	defaultPeriodLength,
	defaultPeriodPeriodicity,
	defaultPeriodBudgetType,
	defaultPeriodHoursAmount,
	defaultPeriodPriceAmount,
	existingValue,
	currency,
	firstPeriodStartDate,
	latestPeriodEndDate,
}) => {
	const [inputValue, setInputValue] = useState(1);
	const [isInputValid, setIsInputValid] = useState(true);

	const handleConfirmButton = () => {
		handleConfirm(inputValue);
		closeModal();
	};

	const onInputChange = value => {
		setIsInputValid(value.length && !isNaN(value) && value > 0 && value - Math.floor(value) === 0);
		setInputValue(value);
	};

	const lastPeriodEndDate =
		latestPeriodEndDate && inputValue > 0 && defaultPeriodLength
			? latestPeriodEndDate.clone().add(defaultPeriodLength * inputValue, defaultPeriodPeriodicity === PERIODICITY.DAILY ? 'days' : defaultPeriodPeriodicity === PERIODICITY.WEEKLY ? 'weeks' : 'months')
			: null;

	const content = (
		<AddPeriodsModalStyle isInputValid={isInputValid}>
			<div className="sub-header">{formatMessage({id: 'retainer.add_multiple_periods'})}</div>
			<div className="input-totals-container">
				<Input
					id="user-input-modal-input"
					label={formatMessage({id: 'retainer.periods'})}
					value={inputValue}
					minNumber={1}
					type={'number'}
					step={1}
					onChange={onInputChange}
					placeholder={''}
					autoFocus={true}
					onEnter={handleConfirmButton.bind(this)}
					cy={'user-input-modal-input'}
				/>
				<div className="retainer-totals" data-cy={'pre-create-periods-retainer-totals'}>
					<div className={'retainer-totals-container dates-section'}>
						<label className={'label'}>{formatMessage({id: 'retainer.new_dates'})}</label>
						<div className={'retainer-bloc dates'}>{firstPeriodStartDate && lastPeriodEndDate ? firstPeriodStartDate.format('ll') + ' - ' + lastPeriodEndDate.format('ll') : null}</div>
					</div>
					{defaultPeriodBudgetType !== PERIOD_BUDGET_TYPE.TIME_AND_MATERIALS ? (
						<div className={'retainer-totals-container value-section'}>
							<label className={'label'}>{formatMessage({id: 'retainer.new_total_value'})}</label>
							<div className={'retainer-bloc value'}>
								<div className={'inner-text'}>
									{defaultPeriodBudgetType === PERIOD_BUDGET_TYPE.FIXED_HOURS
										? Util.convertMinutesToFullHour((existingValue + defaultPeriodHoursAmount * inputValue) * 60, intl, true)
										: Util.getFormattedCurrencyValue(Util.GetCurrencySymbol(currency), existingValue + defaultPeriodPriceAmount * inputValue)}
								</div>
							</div>
						</div>
					) : null}
				</div>
			</div>
		</AddPeriodsModalStyle>
	);
	return (
		<GenericModal
			closeModal={closeModal}
			buttons={[
				{
					text: formatMessage({id: 'common.cancel'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.WHITE,
				},
				{
					text: formatMessage({id: 'common.add'}),
					style: BUTTON_STYLE.FILLED,
					color: BUTTON_COLOR.GREEN,
					callback: handleConfirmButton.bind(this),
					cy: 'user-input-confirm-btn',
					disabled: !isInputValid,
				},
			]}
			headerText={formatMessage({id: 'retainer.new_periods'})}
			content={content}
		/>
	);
};

export default injectIntl(AddPeriodsModal);
